import $ from 'jquery';

(function (A, $) {
  let isLoaded = false;
  A.registerBehavior('WidgetContainerSurveyPreview', function () {
    const settings = A.settings['/themes/custom/js/survey-preview.js'] ?? {};
    if (isLoaded) {
      return;
    }
    if (!settings?.module || !settings?.handler || !settings?.id || !settings?.type) {
      return;
    }
    isLoaded = true; // Set loaded flag to prevent multiple AJAX calls
    Util.ajax(settings.module, settings.handler, {id: settings.id, type: settings.type}, {
      statusCode: {
        200: function (data) {
          if (!('survey' in data && 'options' in data)) {
            return;
          }
          const widget = document.querySelector('survey-preview');
          widget.options = data.options;
          widget.survey = data.survey;
        }
      }
    });
  });
}(App, $));

